import { ExperiencePreview } from '@dadohr/shared/domainTypes/experiencePreview';
import ENV from '../../../../env.json';
import { usePromise } from '../../../../hooks/usePromise';
import {
  LoadingValueLike,
  refreshTimestamp
} from '../../../../services/firebase';

const isLocalhost = () => window.location.host.startsWith('localhost');

type TimestampJsonRepesentation = {
  _seconds: number;
  _nanoseconds: number;
};

const recursivelyParseAndReplaceTimestampsMutable = <T extends Object>(
  o: T
): T => {
  const isTimestampJsonRepresentation = (
    testObject: any
  ): testObject is TimestampJsonRepesentation => {
    return (
      testObject instanceof Object &&
      typeof testObject['_seconds'] === 'number' &&
      typeof testObject['_nanoseconds'] === 'number'
    );
  };
  Object.entries(o).forEach(([key, value]) => {
    if (value instanceof Object) {
      if (isTimestampJsonRepresentation(value)) {
        (o as any)[key] = refreshTimestamp(value);
      } else {
        recursivelyParseAndReplaceTimestampsMutable(value);
      }
    }
  });
  return o;
};

const getExperiencePreviewForToken = async (
  previewToken: string,
  anchorDateString: string
): Promise<ExperiencePreview> => {
  const url = new URL(
    isLocalhost() ? ENV.domains.cf.public : window.location.origin
  );

  url.pathname = isLocalhost()
    ? 'experiencesPreview-getExperiencePreviewForToken'
    : '/api/experiences/preview';
  url.searchParams.set('previewToken', previewToken);
  url.searchParams.set('anchorDateString', anchorDateString);
  const urlString = url.toString();
  const r = await fetch(urlString, {
    redirect: 'follow',
    headers: {
      Accept: 'application/json'
      // Authorization: authToken ? `Bearer ${authToken}` : ''
    }
  });

  console.log('response', r);

  const d:
    | {
        status: 'OK';
        experiencePreview: ExperiencePreview;
      }
    | {
        status: 'ERROR';
        code: string;
      } = await r.json();
  if (d.status === 'OK') {
    console.dir(d.experiencePreview);
    return recursivelyParseAndReplaceTimestampsMutable(d.experiencePreview);
  } else {
    throw Error(d.code);
  }
};

export const useExperiencePreviewFromToken = (
  previewToken: string,
  anchorDateIsoString: string
): LoadingValueLike<ExperiencePreview> =>
  usePromise(
    () => getExperiencePreviewForToken(previewToken, anchorDateIsoString),
    [previewToken, anchorDateIsoString]
  );
